import axios from 'axios'
import { getAuthSession } from '../../Auth/index'
import { baseUrl } from '../config'

/**
 * Remove daily schedule and its program from Program-Patient and Program-Schedule in DynamoDb.
 *
 * @param {String} patientId
 * @param {Object} data
 * @param {String} type of program - either undefined or "modules"
 * @param {Number} index of module id in synced programs link_to list
 * @return {Promise<any>} Updated program and schedule
 */
const removeDailySchedule = (patientId, data, type, index, newData) => {
    return new Promise((resolve, reject) => {
        getAuthSession()
            .then(({ id, accessToken }) => {
                const reqBody = {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    data: { patientId, data, type, index, newData },
                }
                axios
                    .delete(
                        `${baseUrl}/practitioner/${id}/schedule/delete`,
                        reqBody
                    )
                    .then((res) => {
                        const data = res.data
                        resolve(data)
                    })
                    .catch((err) => reject(JSON.stringify(err)))
            })
            .catch((err) =>
                reject(`getAuthSession::error - ${JSON.stringify(err)}`)
            )
    })
}

export default removeDailySchedule
